module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch2"
    }
  }, [_vm._v("DARK-ENIGMA BIRD")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Heaven bade Dark-Enigma bird")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("descend and give birth to Shang,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("our people inhabiting lands boundless and beyond,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("then our Celestial Lord bade brave and forceful T’ang")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("establish boundaries to the far corners of our lands,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("bade him then rule these lands,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("these nine regions in splendor.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("So T’ang, first emperor of Shang,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("received the Mandate. Ever safe,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("it has passed now to Wu Ting’s")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("sons, to his sons and grandsons,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("our emperors brave and forceful,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("nothing they will not overcome—")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("their lords with dragon banners")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("parading grains to the sacrifice,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("their domain thousands of miles")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("offering the people sure support.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He pushed the boundaries of our land to the four seas,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and now from the four seas comes")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("homage, such abounding homage.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And our far frontier is the river.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("That Shang received the Mandate was due, right and due,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and its hundred blessings continue.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f441ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0